export enum USER_FEEDBACK_RESOURCE_TYPE {
  DOCUMENT_REVIEW_AGENT_RUN = 'DOCUMENT_REVIEW_AGENT_RUN',
  CHAT_AGENT_CONVERSATION = 'CHAT_AGENT_CONVERSATION',
  CUSTOMER_FRAUD_REASONING_AGENT_RUN = 'CUSTOMER_FRAUD_REASONING_AGENT_RUN',
}
